import { is, when } from 'ramda';

export const ensureArray = when(Boolean, (data) =>
  is(Array, data) ? data : [data]
);
